import { virtualDir } from "#skyward_global";
import { ButtonDefinition, ButtonIcon, DEFAULT_CANCEL_BUTTON, showCriticalDialog } from "#skyward_modalLayer";
import { checkLoadContent } from "#skyward_window";
import { registerEvents } from "./skyward.ui.events";

interface ApprovalResponse
{
    success: boolean;
    html?: string;
    approvalTypeEnumCode: string;
    approvalType?: number;
    workflowData?: Record<string, string>;
    title?: string;
    redirectAction: string;
}

registerEvents("userApproval", {
    getConsent,
    getConsentForAdd
});

async function getConsent(this: HTMLElement | JQuery<HTMLElement>)
{
    const buttonData = $(this).data();
    try
    {
        const response = await $.ajax({
            url: `${virtualDir}SkySys/UserApproval/GetConsent`,
            type: "POST",
            dataType: "JSON",
            data: buttonData
        });

        handleApprovalResponse(response, buttonData);
    }
    catch (error)
    {
        console.error("Error requesting approval:", error);
    }
}

function handleApprovalResponse(
    data: ApprovalResponse,
    buttonData: Record<string, any>
)
{
    const datas = { ...buttonData, ...data };
    if (data.html)
    {
        const consentButton: ButtonDefinition =
        {
            text: "I Consent",
            icon: ButtonIcon.Check,
            click: consentAndRedirect as unknown as JQuery.EventHandlerBase<Element, JQuery.ClickEvent>,
            data: datas
        };

        const dialogTitle = data.title || "APPROVAL REQUIRED";

        showCriticalDialog(
            dialogTitle,
            data.html,
            [consentButton, DEFAULT_CANCEL_BUTTON],
            { width: 600, automationID: "approval-consent-dialog" }
        );
    }
    else
    {
        handleApprovalRedirect(datas);
    }
}

function consentAndRedirect(this: HTMLElement | JQuery<HTMLElement>)
{
    const buttonData = $(this).data();

    $.ajax({
        url: `${virtualDir}SkySys/UserApproval/ApproveAndRedirect`,
        type: "POST",
        dataType: "JSON",
        data: buttonData,
        success: function (data: ApprovalResponse)
        {
            handleApprovalRedirect(data);
        }
    });
}

async function getConsentForAdd(this: HTMLElement | JQuery<HTMLElement>)
{
    const buttonData = $(this).data();

    let url: string | undefined;
    switch (buttonData.redirectAction)
    {
        case "MassImportAttachmentTemplateAddTemplate":
            url = `${virtualDir}SkySys/UserApproval/GetConsentForAdd`;
            break;
    }

    try
    {
        const response = await $.ajax({
            url: url,
            type: "POST",
            dataType: "JSON",
            data: buttonData
        });

        handleApprovalResponse(response, buttonData);
    }
    catch (error)
    {
        console.error("Error requesting approval:", error);
    }
}

function handleApprovalRedirect(data: ApprovalResponse)
{
    if (!data.success) return;

    switch (data.redirectAction)
    {
        case "MassImportAttachmentTemplateRunImport":
            checkLoadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/SkySys/MassImportAttachmentRun/RunImport', null, data.workflowData, null, undefined, null, false, null, null, null);
            break;
        case "MassImportAttachmentTemplateAddTemplate":
            checkLoadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/SkySys/MassImportAttachmentTemplate/Add', null, data.workflowData, null, undefined, null, false, null, null, null);
            break;
        case "MassDelete":
            checkLoadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/WSIPCOnly/WSIPCOnly/MassDelete', null, data.workflowData, null, undefined, null, false, null, null, null);
            break;
    }
}
